import { render, staticRenderFns } from "./jhi-footer.vue?vue&type=template&id=fc9b8072&scoped=true&"
import script from "./jhi-footer.vue?vue&type=script&lang=ts&setup=true&"
export * from "./jhi-footer.vue?vue&type=script&lang=ts&setup=true&"
import style0 from "./jhi-footer.vue?vue&type=style&index=0&id=fc9b8072&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fc9b8072",
  null
  
)

export default component.exports